// extracted by mini-css-extract-plugin
export default {"card":"SingleCard_card__LFcgv","image":"SingleCard_image__lHTAa","table":"SingleCard_table__AT71h","reset":"SingleCard_reset__6O3Cw"};